import uppyLocaleEn from '@uppy/locales/lib/en_US.js';

export default {
  Language: 'Language',
  Create: 'Create',
  Close: 'Close',
  Cancel: 'Cancel',
  Save: 'Save',
  Edit: 'Edit',
  Crop: 'Crop',
  Rotate: 'Rotate',
  Grayscale: 'Grayscale',
  Adjust: 'Adjust',
  Apply: 'Apply',
  Reset: 'Reset',
  Brightness: 'Brightness',
  Contrast: 'Contrast',
  Saturation: 'Saturation',
  Original: 'Original',
  'Rotate left 90°': 'Rotate left 90°',
  'Rotate right 90°': 'Rotate right 90°',
  'Flip horizontal': 'Flip horizontal',
  'Flip vertical': 'Flip vertical',
  'File info': 'File info',
  Type: 'Type',
  Dimensions: 'Dimensions',
  Duration: 'Duration',
  Path: 'Path',
  'Download help': 'Download help',
  'Discard unsaved changes?': 'You have unsaved changes. Discard?',
  Editing: 'Editing',
  Unsaved: 'Unsaved',
  'File %s of %s': 'File %s of %s',
  'Toggle word wrap': 'Toggle word wrap',
  'Word wrap on — click to disable': 'Word wrap on — click to disable',
  'Word wrap off — click to enable': 'Word wrap off — click to enable',
  'New Folder': 'New Folder',
  'New File': 'New File',
  Rename: 'Rename',
  'Failed to rename': 'Failed to rename',
  'Name cannot contain slashes.': 'Name cannot contain slashes.',
  'Zoom in': 'Zoom in',
  'Zoom out': 'Zoom out',
  'Reset zoom': 'Reset zoom',
  'Sort by': 'Sort by',
  'Name (A-Z)': 'Name (A-Z)',
  'Name (Z-A)': 'Name (Z-A)',
  'Size (smallest)': 'Size (smallest)',
  'Size (largest)': 'Size (largest)',
  'Date (newest)': 'Date (newest)',
  'Date (oldest)': 'Date (oldest)',
  Delete: 'Delete',
  Upload: 'Upload',
  Download: 'Download',
  Archive: 'Archive',
  Unarchive: 'Unarchive',
  Open: 'Open',
  'Open containing folder': 'Open containing folder',
  Refresh: 'Refresh',
  Preview: 'Preview',
  'Preview as': 'Preview as',
  Text: 'Text',
  Image: 'Image',
  Table: 'Table',
  Raw: 'Raw',
  'View as table': 'View as table',
  'View as raw': 'View as raw',
  'Show as table': 'Show as table',
  'Failed to parse CSV': 'Failed to parse CSV',
  'No rows to display': 'No rows to display',
  'Showing first %s rows out of %s': 'Showing first %s rows out of %s',
  'Toggle Full Screen': 'Toggle Full Screen',
  'Change View': 'Change View',
  Storage: 'Storage',
  'Go up a directory': 'Go up a directory',
  'Enter folder path:': 'Enter folder path:',
  'Invalid path format. Path must be in format: storage://path/to/folder':
    'Invalid path format. Path must be in format: storage://path/to/folder',
  'Invalid storage. Storage "%s" is not available.':
    'Invalid storage. Storage "%s" is not available.',
  'Failed to navigate to folder': 'Failed to navigate to folder',
  'Copy Path': 'Copy Path',
  'Path copied to clipboard': 'Path copied to clipboard',
  'Toggle Path Copy Mode': 'Toggle Path Copy Mode',
  'Copy Download URL': 'Copy Download URL',
  'Search anything..': 'Search anything..',
  Name: 'Name',
  Size: 'Size',
  Date: 'Date',
  Filepath: 'Filepath',
  'Folder Name': 'Folder Name',
  'File Name': 'File Name',
  'Move files': 'Move files',
  'Yes, Move!': 'Yes, Move!',
  'Delete files': 'Delete files',
  'Yes, Delete!': 'Yes, Delete!',
  'Upload Files': 'Upload Files',
  'No files selected!': 'No files selected!',
  'Select Files': 'Select Files',
  'Archive the files': 'Archive the files',
  'Unarchive the files': 'Unarchive the files',
  'The archive will be unarchived at': 'The archive will be unarchived at',
  'Archive name. (.zip file will be created)': 'Archive name. (.zip file will be created)',
  'Target folder': 'Target folder',
  'A modern, customizable file manager component built for Vue.':
    'A modern, customizable file manager component built for Vue.',
  'Create a new folder': 'Create a new folder',
  'Create a new file': 'Create a new file',
  'Are you sure you want to delete these files?': 'Are you sure you want to delete these files?',
  "I'm sure delete it, This action cannot be undone.":
    'I confirm I want to delete this. This action cannot be undone.',
  'Search results for': 'Search results for',
  '%s item(s) selected.': '%s item(s) selected.',
  '%s is renamed.': '%s is renamed.',
  'This is a readonly storage.': 'This is a readonly storage.',
  '%s is created.': '%s is created.',
  'Files moved.': 'Files moved.',
  'Files deleted.': 'Files deleted.',
  'The file unarchived.': 'The file unarchived.',
  'The file(s) archived.': 'The file(s) archived.',
  'Updated.': 'Updated.',
  'No search result found.': 'No search result found.',
  'Are you sure you want to move these files?': 'Are you sure you want to move these files?',
  'File Size': 'File Size',
  'Last Modified': 'Last Modified',
  'Select Folders': 'Select Folders',
  'Clear all': 'Clear all',
  'Clear only successful': 'Clear only successful',
  'Drag and drop the files/folders to here.': 'Drag and drop the files/folders to here.',
  'You can drag & drop files anywhere while this modal is open.':
    'You can drag & drop files anywhere while this modal is open.',
  Canceled: 'Canceled',
  Done: 'Done',
  'Network Error, Unable establish connection to the server or interrupted.':
    'Network Error, Unable establish connection to the server or interrupted.',
  'Pending upload': 'Pending',
  'Please select file to upload first.': 'Please select file to upload first.',

  Settings: 'Settings',
  Shortcuts: 'Shortcuts',
  Escape: 'Escape',
  Search: 'Search',
  'Toggle Sidebar': 'Toggle Sidebar',
  'Open Settings': 'Open Settings',
  'Reset all settings to default': 'Reset all settings to default',
  'Saved.': 'Saved.',
  'Reset Settings': 'Reset Settings',
  'Download doesn\'t work? You can try right-click "Download" button, select "Save link as...".':
    'Download doesn\'t work? You can try right-click "Download" button, select "Save link as...".',
  Theme: 'Theme',
  'Target Directory': 'Target Directory',
  Select: 'Select',
  'Show thumbnails': 'Show thumbnails',
  'Persist Path': 'Persist Path',
  'Metric Units': 'Metric Units',
  'Select All': 'Select All',
  'Pinned Folders': 'Pinned Folders',
  'No folders pinned': 'No folders pinned',
  'No folders': 'No folders',
  'No items': 'No items',
  'Pin Folder': 'Pin Folder',
  'Unpin Folder': 'Unpin Folder',
  Pinned: 'Pinned',

  'Project Home': 'Project Home',
  'If you like it, please follow and ⭐ star on GitHub.':
    'If you like it, please follow and ⭐ star on GitHub.',
  'Follow on GitHub': 'Follow on GitHub',
  'Customize your experience with the following settings':
    'Customize your experience with the following settings',
  File: 'File',
  View: 'View',
  Tools: 'Tools',
  Help: 'Help',
  Exit: 'Exit',
  'Deselect All': 'Deselect All',
  Cut: 'Cut',
  Copy: 'Copy',
  Paste: 'Paste',
  'Grid View': 'Grid View',
  'List View': 'List View',
  'Tree View': 'Tree View',
  'Show Thumbnails': 'Show Thumbnails',
  'Full Screen': 'Full Screen',
  items: 'items',
  selected: 'selected',
  About: 'About',
  Git: 'Git',
  Forward: 'Forward',
  Back: 'Back',
  'Go to Folder': 'Go to Folder',
  Go: 'Go',
  Recent: 'Recent',
  'Remove from recent': 'Remove from recent',
  'Edit this path': 'Edit this path',
  'No recent folders yet.': 'No recent folders yet.',
  'No matching folders.': 'No matching folders.',
  'Folder not found': 'Folder not found',
  'Loading…': 'Loading…',
  Sorting: 'Sorting',
  Asc: 'Asc',
  Desc: 'Desc',
  None: 'None',
  Show: 'Show',
  'All items': 'All items',
  'Files only': 'Files only',
  'Folders only': 'Folders only',
  'Show hidden files': 'Show hidden files',
  'Copy files': 'Copy files',
  'Are you sure you want to copy these files?': 'Are you sure you want to copy these files?',
  'Yes, Copy!': 'Yes, Copy!',
  'Files copied.': 'Files copied.',
  Browse: 'Browse',
  'Create a copy instead of moving': 'Create a copy instead of moving',
  'Select Target Folder': 'Select Target Folder',
  Storages: 'Storages',
  Loading: 'Loading',
  'Search files': 'Search files',
  'Failed to open containing folder': 'Failed to open containing folder',
  'Include subfolders': 'Include subfolders',
  'More actions': 'More actions',
  'Open Containing Folder': 'Open Containing Folder',
  'Searching...': 'Searching...',
  'No results found': 'No results found',
  'Search Options': 'Search Options',
  'All Files': 'All Files',
  'Small (< 1MB)': 'Small (< 1MB)',
  'Medium (1-10MB)': 'Medium (1-10MB)',
  'Large (> 10MB)': 'Large (> 10MB)',
  'Start typing to search files. Use options to filter or include subfolders.':
    'Start typing to search files. Use options to filter or include subfolders.',
  uppy: uppyLocaleEn,
};
